export default "__VITE_ASSET__BeUVoceh__"